export default __webpack_public_path__ + "static/media/christine.17bc02a2.jpg";